import Label from "./common/Label";
import Description from "./common/Description";

const Select = ({
    label,
    value,
    onChange,
    name,
    options = [],
    placeholder = "Select an option",
    description,
    help,
    className,
    containerClass,
    ...props
}) => {
    // Helper function to check if options contain groups
    const hasGroups = options.length > 0 && options[0].hasOwnProperty("group");

    return (
        <div className={containerClass}>
            <Label label={label} help={help} />
            <select
                id={name}
                name={name}
                value={value}
                onChange={(e) => onChange(name, e.target.value)}
                className={`w-full max-w-none px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
                {...props}
            >
                {placeholder && <option value="">{placeholder}</option>}

                {hasGroups
                    ? // Render with optgroups
                      options.map((group, groupIndex) => (
                          <optgroup key={groupIndex} label={group.group}>
                              {group.options.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                  </option>
                              ))}
                          </optgroup>
                      ))
                    : // Render normal options
                      options.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                              {opt.label}
                          </option>
                      ))}
            </select>

            <Description description={description} />
        </div>
    );
};

export default Select;
